import { CheckCovered } from "./../../Public/assets";
import React from "react";

function FreeAccountSection() {
  const features = [
    { text: "No SSN" },
    { text: "No foreign visa required" },
    { text: "No minimum balance" },
    { text: "No opening charges" },
  ];
  return (
    <div className="px-6 bg-colorMobile sm:bg-justPassport  bg-cover bg-no-repeat pt-[50px] md:pt-[60px] lg:pt-[128px]  w-full mx-auto text-center">
      <h1 className="text-[28px] md:text-[38px]  md:leading-[52px] lg:text-[52px]  lg:leading-[65px] font-IvyJournal  font-[400] text-[#000] mb-[32px] mx-auto md:w-1/2">
        Open a free account with just your{" "}
        <span className="text-blueish  text-[28px] md:text-[38px] md:leading-[52px] lg:text-[52px] lg:leading-[65px] font-IvyJournal  font-[400] ">
          passport
        </span>
      </h1>

      <div className="flex flex-wrap justify-center gap-4 mt-[32px] pb-[68px]">
        {features.map((feature, index) => (
          <div key={index} className="flex items-center gap-2 text-blue-600">
            <img src={CheckCovered} alt="" className="w-5 md:w-auto" />
            <span className="font-geomanistBold font-[400] text-[13px] md:text-[22px] leading-[23px] md:leading-[36px]">
              {feature.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FreeAccountSection;
